<template>
  <div class="heading-component">
    <div class="video-container">
      <video
          v-if="!showModal"
          ref="videoElement"
          :poster="videoPoster"
          :src="videoSrc"
          autoplay
          class="heading-video d-none d-md-block"
          loop
          muted
      >
        Your browser does not support the video tag.
      </video>
      <video
          v-if="!showModal"
          ref="videoElement"
          :poster="videoPoster"
          :src="videoSrc"

          class="heading-video d-md-none"
          loop
          muted
      >
        Your browser does not support the video tag.
      </video>
      <div class="overlay-content">
        <div class="unihospital-logo">
          <UniHospitalLogoNoText/>
        </div>
        <div class="video-title">
          <div>{{ $t('home-heading-video-title-line-1') }}</div>
          <div>{{ $t('home-heading-video-title-line-2') }}</div>
        </div>
        <div class="video-description">{{ $t('home-heading-video-description') }}</div>
        <div class="d-md-flex">
          <div v-if="false" class="heading-video-buttons">
            <router-link :to="{ name: 'ServicesView' }">
              <div>
                <MainButton :button-text="$t('home-heading-button-solid')" size="medium" theme="outline-white"/>
              </div>
            </router-link>
          </div>
          <div class="heading-video-buttons">
            <div>
              <MainButton :button-text="$t('home-heading-button-outline')"
                          size="medium"
                          theme="outline-white"
                          @click="openOfficesModal"/>
            </div>
          </div>
        </div>
        <button v-if="!showModal" class="play-button d-flex align-items-center" @click="playVideo">
          <PlayButtonIcon/>
          <div class="ms-2">{{ $t('home-heading-play-button') }}</div>
        </button>
      </div>
    </div>

    <!-- Modal for the iframe -->
    <div v-if="showModal" class="video-modal">
      <button class="close-button" @click="closeModal">×</button>
      <div class="video-modal-content">

        <iframe
            :src="iframeSrc"
            allow="autoplay; encrypted-media"
            allowfullscreen
            class="modal-iframe"
            frameborder="0"
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, onUnmounted} from 'vue';
import UniHospitalLogoNoText from "@/components/Common/Icons/UniHospitalLogoNoText.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import PlayButtonIcon from "@/components/Common/Icons/PlayButtonIcon.vue";
import store from "@/store";

export default {
  name: 'HeadingComponent',
  components: {PlayButtonIcon, MainButton, UniHospitalLogoNoText},
  setup() {
    const isMobile = ref(false);
    const videoSrc = ref('');
    const videoPoster = ref('');
    const videoElement = ref(null);
    const showModal = ref(false); // State to control modal visibility
    const iframeSrc = ref(''); // State for the iframe URL

    const openOfficesModal = () => {
      store.dispatch("utils/toggleOfficesModal", true);
    };

    const checkDevice = () => {
      isMobile.value = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile.value) {
        videoSrc.value = '/static/videos/short.mp4';
        videoPoster.value = '/static/images/HeadingVideoPosterMobile.webp';
      } else {
        videoSrc.value = '/static/videos/short.mp4';
        videoPoster.value = '/static/images/HeadingVideoPosterDesktop.webp';
      }
    };

    const playVideo = () => {
      showModal.value = true;
      iframeSrc.value = 'https://www.youtube.com/embed/kWIVuInpIpc?autoplay=1';
    };

    const closeModal = () => {
      showModal.value = false;
      iframeSrc.value = ''; // Clear the iframe src when closing the modal
    };

    onMounted(() => {
      checkDevice();
      window.addEventListener('resize', checkDevice);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkDevice);
    });

    return {
      videoSrc,
      videoPoster,
      videoElement,
      showModal,
      iframeSrc,
      playVideo,
      closeModal,
      openOfficesModal
    };
  },
};
</script>


<style lang="scss" scoped>
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8); /* Dark semi-transparent background */
  z-index: 9999; /* Ensure the modal is on top */
}

.video-modal-content {
  position: relative;
  min-width: 80%;
  background-color: #000; /* Black background for modal content */
  padding: 0;
  border-radius: 10px;
  overflow: hidden;
  z-index: 10;
}

.modal-iframe {
  width: 100%;
  height: 400px; /* Adjust the height as needed */
}

.close-button {
  position: absolute;
  top: 5%;
  right: 5%;
  font-size: 54px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  z-index: 10000; /* Ensure it's on top of everything */
}

.close-button:hover {
  color: red; /* Change color on hover for better UX */
}

.heading-component {
  position: relative;
  text-align: center;
  font-family: $font-regular;
}

.heading-video {
  width: 100%;
  height: 700px;
  object-fit: cover; /* Ensures the video fits within the container without overflowing */
  cursor: pointer;
}

.video-container {
  position: relative;
  width: 100%;
  height: 100%; /* Ensure the container takes the full height of its parent */
  margin: 0 auto;
  overflow: hidden; /* Prevents any overflow */
}

.overlay-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;

  .video-title {
    font-family: $font-regular;
    font-size: $title-h3;
    line-height: $title-h4;
    margin: $spacing-2 0;
    width: 90%;
  }

  .video-description {
    font-size: $paragraph-2;
    margin-bottom: $spacing-4;
    width: 80%;
  }

  .play-button {
    margin-top: $spacing-3;
    font-size: 14px;
    padding: 0.5rem 1rem;
    background: none;
    border: none;
    color: $color-white;
    cursor: pointer;
  }

  .heading-video-buttons {
    margin: 0 10px $spacing-2;
    min-width: 200px;
  }

  .unihospital-logo {
    margin-top: $spacing-11;
    animation: rotate 15s linear infinite;
  }

}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media screen and (min-width: 768px) {
  .heading-video {
    border-radius: 30px;
    overflow: hidden;
  }
  .overlay-content {
    .video-title {
      font-size: $title-h3;
      line-height: $title-h3;
      text-align: center;
    }

    .video-description {
      width: 40%;
      margin-bottom: $spacing-8;
    }
  }
  .modal-iframe {
    height: 700px; /* Adjust the height as needed */
  }

}

@media screen and (min-width: 1450px) {
  .heading-video {
    height: 850px;
  }
  .modal-iframe {
    height: 850px; /* Adjust the height as needed */
  }

}

</style>
